import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Mesaje e-mail',
  labels: {
    view_full_message: 'Vezi mesajul complet',
    status: 'Stare:',
    on: 'Activat',
    off: 'Dezactivat',
    next_send: 'Următoarea trimitere: {{date}}.',
  },
  descriptions: {
    welcome:
      'Trimis o singură dată când un client se abonează la e-mailurile tale de marketing, cu excepția înscrierilor prin formularul vitrinei tale. Un client primește doar unul dintre Welcome, Welcome members club și Launch deal.',
    welcome_members_club:
      'Trimis o singură dată când cineva se înscrie prin formularul vitrinei tale și nu este configurat niciun cod promoțional de înscriere, sau se alătură listei tale de membri VIP. Un client primește doar unul dintre Welcome, Welcome members club și Launch deal.',
    storefront_promo:
      'Trimis o singură dată când cineva se înscrie prin formularul vitrinei tale, iar un cod promoțional de înscriere este configurat. E-mailul conține codul promoțional personal al clientului.',
    launch_deal:
      'Trimis o singură dată clienților tăi importați, la 30 de minute după ce restaurantul tău devine activ. Clienții care au primit deja Welcome sau Welcome members club sunt omiși.',
    we_miss_you:
      'Trimis abonaților a căror ultimă comandă a fost acum mai bine de 45 de zile. Verificat în fiecare dimineață; un client îl primește cel mult o dată la 45 de zile.',
    happy_friday:
      'Trimis tuturor abonaților la 08:00 UTC în prima vineri a fiecărei luni pare (februarie, aprilie, iunie, august, octombrie, decembrie).',
    lazy_sunday:
      'Trimis tuturor abonaților la 08:00 UTC în prima duminică a fiecărei luni impare (ianuarie, martie, mai, iulie, septembrie, noiembrie).',
    loyalty_program:
      'Trimis atunci când soldul de cashback al unui client atinge minimul pe care îl poate cheltui. Un client îl primește cel mult o dată la 30 de zile.',
    you_might_also_like:
      'Trimis la 3 zile după o comandă cu cel puțin 2 produse identice, cu prețul de 6,00 sau mai mult, recomandând unul dintre cele mai populare produse ale tale. Un client îl primește cel mult o dată la 30 de zile.',
  },
  tiles: {
    sends_count: 'Mesaje trimise',
    delivery_rate: 'Rată livrare',
    delivered_suffix: 'livrate',
    open_rate: 'Rată deschidere',
    opened_suffix: 'deschise',
    click_rate: 'Rată accesare',
    clicked_suffix: 'accesate',
    spam_report_rate: 'Rată raportare spam',
    spam_reports_suffix: 'raportări',
    unsubscribe_rate: 'Rată dezabonare',
    unsubscribes_suffix: 'dezabonări',
  },
  toasts: {
    failed_to_update_status: 'Eroare la actualizarea stării',
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },

  preview_modal: {
    title: 'Previzualizare șablon',
    labels: {
      subject: 'Subiect:',
      close: 'Închide',
    },
    toasts: {
      failed_to_load_data: 'Eroare la încărcarea previzualizării',
    },
    template_data: {
      recipient_name: '&lt;Prenume&gt;',
    },
  },
};
